module.exports = __webpack_public_path__ + "img/hardware.4cacca29.svg";